import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './plugins/clipboard';
import vuetify from './plugins/vuetify';
import './assets/styles.scss';

Vue.config.productionTip = false;

new Vue({
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
